import { basePath } from '../next.config'
import loggingService from './loggingService'

const getDownloadUrl = async (
	tracks: Track | Track[],
	fileType: string,
	projectName: string | null
): Promise<string> => {
	let response: Response

	const isBulkDownload = Array.isArray(tracks)

	const body = {
		tracks: isBulkDownload ? tracks : [tracks],
		fileType: fileType,
		projectName: projectName,
	}

	try {
		response = await fetch(`${basePath}/api/musicapp/downloads`, {
			body: JSON.stringify(body),
			method: 'POST',
		})

		if (!response.ok) {
			throw new Error(response.status.toString())
		}

		return await response.json()
	} catch (error) {
		loggingService('Error getting download URL', error, {
			errorType: 'Download',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
	}
}

const getFile = async (url: string): Promise<Response> => {
	let response: Response
	try {
		response = await fetch(url, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/octet-stream',
			},
		})

		if (!response.ok) {
			throw new Error(response.status.toString())
		}

		return response
	} catch (error) {
		loggingService('Error retrieving download', error, {
			errorType: 'Download API',
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
	}
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const downloadTracks = async (
	tracks: Track | Track[],
	fileType: string,
	projectName: string | null = null
): Promise<Response> => {
	const downloadUrl = await getDownloadUrl(tracks, fileType, projectName)

	const response = await getFile(downloadUrl)

	return response
}
